import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ENVIRONMENT } from '@hmax-order/frontend/environment';
import { DateLike } from '@hmax-order/shared/date';
import { Company } from '@prisma/client';

@Injectable({ providedIn: 'root' })
export class CompanyDemoService {
  private _env = inject(ENVIRONMENT);
  private _http = inject(HttpClient);
  private _url = `${this._env.apiUrl}/demo`;
  private _urlCompanies = `${this._env.apiUrl}/companies`;
  private _urlResendCredentials = `${this._url}/auth/forgot-password`;
  private _urlResetToken = `${this._url}/auth/reset-token`;

  getDemoList(period?: { createdStart?: DateLike; createdEnd?: DateLike }): Observable<Company[]> {
    let params = new HttpParams();
    if (period?.createdStart) {
      params = params.set('createdStart', period.createdStart.toString());
    }
    if (period?.createdEnd) {
      params = params.set('createdEnd', period.createdEnd.toString());
    }

    return this._http.get<Company[]>(this._url, { params });
  }

  resendCredentials(companyId: string) {
    return this._http.post(`${this._urlResendCredentials}`, { companyId });
  }

  /**
   * Obter o token de redefinição de senha do Owner da empresa demo, sem disparar e-mail,
   * para que o link possa ser copiado e enviado manualmente pelo suporte
   */
  getResetToken(companyId: string): Observable<{ token: string }> {
    return this._http.get<{ token: string }>(`${this._urlResetToken}/${companyId}`);
  }

  /**
   * Prorroga a demonstração da empresa a partir da data atual.
   * @param days Quantidade de dias (1 a 14). Se não informado, o backend usa 14 como padrão.
   */
  extendDemo(id: string, days?: number): Observable<Company> {
    const body = days != null ? { days } : {};
    return this._http.patch<Company>(`${this._urlCompanies}/${id}/extend-demo`, body);
  }

  removeCompany(id: string): Observable<Company> {
    return this._http.delete<Company>(`${this._urlCompanies}/${id}`);
  }
}
